var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-breadcrumb',{staticClass:"hello_title",attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.dataList),function(item){return _c('el-breadcrumb-item',{key:item},[_vm._v(_vm._s(item))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }